<template>
  <!--  -->
  <div class="policy-release">
    <div style='padding: 20px; background: #fff'>
      <div class="titleMain">
          <span class="titleSpan">信用评分</span>
          <span class="titleName">　>　{{tableData.creditGradeVO.corpName}}</span>
      </div>
      <div class="container">
          <div class="title">{{tableData.creditGradeVO.corpName}}</div>
          <Row style="margin-bottom:20px;">
              <Col span="4">主题类型：企业单位</Col>
              <Col span="4">企业类型：{{tableData.creditGradeVO.corptName}}</Col>
              <Col span="4">更新日期：{{tableData.creditGradeVO.updateDate}}</Col>
              <Col span="4">计算日期：{{tableData.creditGradeVO.goodCreateDate?tableData.creditGradeVO.goodCreateDate:tableData.creditGradeVO.badCreateDate}}</Col>
              <Col span="4">当日分值：{{tableData.creditGradeVO.creditScore}}分</Col>
              <Col span="4">上季度分值：{{tableData.creditGradeVO.quarterCreditScore}}分</Col>
          </Row>
          <div class="colTitle">综合指标</div>
          <div class="colTitleTag">
              <span>
                  基准分:<span class="blueText">　80分　　</span>
                  当日信用分值:<span class="blueText">　{{tableData.creditGradeVO.creditScore}}分　　</span>
                  上一季度分值:<span class="blueText">　{{tableData.creditGradeVO.quarterCreditScore}}分　　</span>
                  同比:<span v-if="tableData.creditGradeVO.quarterCreditScore>tableData.creditGradeVO.quarterCreditScore" class="redText">　下降↓　</span>
                  <span v-else class="greenText">　上升↑　　</span>
              </span>
          </div>
          <div class="colTitle">加分指标</div>
          <div class="colTitleTag">
              <span>
                  加分次数:<span class="blueText">　{{tableData.plusCount}}次　</span>
                  合计加分值:<span class="blueText">　{{tableData.plusScore}}分　</span>
              </span>
          </div>
          <div class="tableMain">
              <Table no-data-text='无数据' :columns="goodColumns" border :data="tableData.goodList" highlight-row></Table>
          </div>
          <div class="colTitle">扣分指标</div>
          <div class="colTitleTag">
              <span>
                  扣分次数:<span class="blueText">　{{tableData.subCount}}次　</span>
                  合计扣分值:<span class="blueText">　{{tableData.subScore}}分　</span>
              </span>
          </div>
          <div class="tableMain">
              <Table no-data-text='无数据' :columns="badColumns" border :data="tableData.badList" highlight-row></Table>
          </div>
          <div class="info">
              <p>评分说明</p>
              <p>1、最终信用分值=80-扣分合计值+加分合计值。（加分合计值超过20分，按20分计；最终信用分值小于0分，按0分计。）</p>
              <p>2、同一工程项目获得多个优良信用信息的，在同一时点获得多个加分值时，按最高加分值计，不累计加分。</p>
              <p>3、同一事项产生的不良信用信息，在同一时点对应多个扣分值时，按最高扣分值计，不累计扣分。</p>
              <p>4、当日公布的季度诚信分是指上一季度的综合信用评价得分的算数平均值。</p>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getCreditGradeInfo } from "@/api/homePage.js";

export default {
  name: "",
  props: {},
  data() {
    return {
      carousel: 0,
      imgList: [],
      tableData: {
          creditGradeVO: {
              corpName:''
          }
      },
      searchParam: {
        dicBazaarId: "",
        corpCode: "",
      },
      goodColumns:[
            {
                title: '序号',
                type: 'index',
                width: 70,
                align: 'center',
                className: 'cell-hmd'
            },
            {
                title: '信用记录编号',
                key: 'creditCode',
                width: 150,
                align: 'center',
                className: 'cell-hmd'
            },
            {
                title: '认定部门',
                key: 'awardDepartment',
                align: 'center',
                width: 150,
                className: 'cell-hmd'
            },
            {
                title: '行为结果描述',
                key: 'fContent',
                align: 'center',
                minWidth: 150,
                className: 'cell-hmd'
            },
            {
                title: '信用分值变化',
                key: 'scoreChange',
                align: 'center',
                width: 100,
                className: 'cell-hmd'
            },
            {
                title: '级别',
                key: 'departLevel',
                align: 'center',
                width: 100,
                className: 'cell-hmd'
            },
            {
                title: '认定时间',
                key: 'createDate',
                align: 'center',
                width: 140,
                className: 'cell-hmd'
            }
        ],
      badColumns:[
            {
                title: '序号',
                type: 'index',
                width: 70,
                align: 'center',
                className: 'cell-hmd'
            },
            {
                title: '信用记录编号',
                key: 'creditCode',
                width: 150,
                align: 'center',
                className: 'cell-hmd'
            },
            {
                title: '认定部门',
                key: 'departName',
                align: 'center',
                width: 150,
                className: 'cell-hmd'
            },
            {
                title: '不良行为类型',
                key: 'fCreditType',
                align: 'center',
                width: 150,
                className: 'cell-hmd'
            },
            {
                title: '行为结果描述',
                key: 'fContent',
                align: 'center',
                minWidth: 150,
                className: 'cell-hmd'
            },
            {
                title: '信用分值变化',
                key: 'scoreChange',
                align: 'center',
                width: 100,
                className: 'cell-hmd'
            },
            {
                title: '级别',
                key: 'departLevel',
                align: 'center',
                width: 100,
                className: 'cell-hmd'
            },
            {
                title: '认定时间',
                key: 'createDate',
                align: 'center',
                width: 140,
                className: 'cell-hmd'
            }
        ]
    };
  },
  components: {},
  computed: {},
  watch: {},
  created() {
      // console.log(this.$route.query.row)
      this.searchParam.dicBazaarId = this.$route.query.row.dicBazaarId
      this.searchParam.corpCode = this.$route.query.row.corpCode
      this.getTableData()
  },
  mounted() {},
  methods: {
    handleSearch() {
      this.getTableData();
    },
    handleInitParam() {
      this.searchParam = {
        dicBazaarId: "",
        corpName: "",
        lowScore: "",
        highScore: "",
        page: 1,
        pageSize: 10
      };
    },
    // 获取表格数据
    getTableData() {
      getCreditGradeInfo(this.searchParam).then(res => {
          // console.log(res);
          if (!res) return this.$Message.error("获取列表信息失败");
          this.totalCount = res.data.totalCount;
          this.tableData = res.data;
          // console.log(this.$store.state._dict.market_type)
            for(let j in this.$store.state._dict.market_type) {
                if(this.tableData.creditGradeVO.dicBazaarId == this.$store.state._dict.market_type[j].dicCode) {
                    this.tableData.creditGradeVO.corptName = this.$store.state._dict.market_type[j].dicName
                }
            }
        })
        .catch(() => {
          this.$Message.error("获取列表信息失败");
        });
    },
    /*处理操作*/
    handleDeal(name, uuid) {
      this.$router.push({
        name: name,
        query: {
          uuid
        }
      });
    },
    handleTypeChange(val) {}
  }
};
</script>

<style lang="less" scoped>

.policy-release {
  background: #f5f5f5;
  padding: 20px;
  height: 100%;
  margin: 0px 8%;
  .cover-table {
    background: #fff;
    border-radius: 4px;
    margin: 20px;
  }
  .titleMain {
      height: 40px;
      line-height: 40px;
      .titleSpan {
          font-size: 12px;
          color: gray;
      }
      .titleName {
          font-size: 12px;
      }
  }
  .container {
      padding: 15px 30px 30px;
      .title {
          font-size: 22px;
          font-weight: 700;
          height: 100px;
          line-height: 100px;
          text-align: center;
      }
      .ivu-col-span-4 {
          text-align: center;
      }
      .colTitle {
          height: 30px;
          line-height: 30px;
          font-size: 18px;
          font-weight: 700;
          padding: 0 15px;
          background: #E1EEFE;
      }
      .colTitleTag {
          height: 60px;
          padding: 0 30px;
          line-height: 60px;
          .blueText {
              color: #1890FF;
          }
          .redText {
              color: red;
          }
          .greenText {
              color: green;
          }
      }
      .tableMain {
          padding-bottom: 20px;
           .cell-hmd {
                padding: 0px;
                color: #808080;
            }
            .color-black08 {
                color: #808080;
            }
      }
      .info {
          padding: 30px 0;
          border-top: 1px solid #cccccc;
      }
  }
}
</style>
<style lang="less">
    .tableMain {
        .cell-hmd {
            padding: 0px;
            color: #808080;
        }
    }
</style>
